import { CustomerForm } from 'app/hooks/useOrderCheckout';
import { CustomersCreateableInterface } from 'ks-common';
import { formatCountryCode, getNationalNumber } from './phone';

type CustomerParser = (customer: CustomerForm) => CustomersCreateableInterface;

const customerParserToCheckout: CustomerParser = customer => {
  return {
    FullName: `${customer.firstName} ${customer.lastName}`,
    CellPhone: customer.primaryCellPhone
      ? getNationalNumber(
          customer.primaryCellPhone,
          customer.countryCodeCellPhone || '',
        )
      : customer.primaryCellPhone,
    Address1: customer.billingAddress1,
    City: customer.city,
    State: customer.state,
    Zip: customer.zipCode,
    Country: customer.country,
    Email: customer.emailAddress,
    ...(!!customer.secondaryCellPhone && {
      SecondCellPhone: getNationalNumber(
        customer.secondaryCellPhone,
        customer.countryCodeSecondCellPhone || '',
      ),
    }),
    ...(!!customer.secondaryEmail && { SecondEmail: customer.secondaryEmail }),
    ...(!!customer.billingAddress2 && { Address2: customer.billingAddress2 }),
    ...(!!customer.countryCodeCellPhone && {
      CountryCodeCellPhone: formatCountryCode(customer.countryCodeCellPhone),
    }),
    ...(!!customer.countryCodeSecondCellPhone && {
      CountryCodeSecondCellPhone: formatCountryCode(
        customer.countryCodeSecondCellPhone,
      ),
    }),
    ...(customer.preferredContactMethod !== undefined && {
      PreferredContactMethod: customer.preferredContactMethod,
    }),
  };
};

export default customerParserToCheckout;
